/*  ========================================================================
    # Scripts - CTA
    ========================================================================  */

/**
 * Open/close the mobile navigation.
 */

const CTA = {
  cfg: {
    cta: document.querySelector('.s-cta')
  },

  /**
   * Initialize.
   */
  init() {
    if (typeof this.cfg.cta !== undefined && this.cfg.cta !== null) {
      setInterval(() => {
        const rect = this.cfg.cta.getBoundingClientRect();
        const visible = rect.top <= window.innerHeight * 0.2;
        this.cfg.cta.setAttribute('data-visible', visible ? '1' : '0');
      }, 100);
    }
  }
};

export default CTA;
